import { RootState, LoggerService } from '@umanforge/common';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { AvatarService } from '../../services/avatar.service';

import DefaultAvatar from '../../assets/default_avatar.png';
import { NavigationService } from '../../services/navigation.service';
import { useNavigate } from 'react-router-dom';

interface HomeTopBarProps {
  title: string;
  needConfirmationToNav: boolean;
}

export function HomeTopBar( { title, needConfirmationToNav }: HomeTopBarProps ) {
  const me = useSelector( ( state: RootState ) => { return state.user.value; } );
  const token = useSelector( ( state: RootState ) => { return state.token.value; } );
  const dispatch = useDispatch();
  const logger: LoggerService = new LoggerService( 'HomeTopBar' );
  const [ avatarUrl, setAvatarUrl ] = useState<string | null>( null );

  useEffect( () => {
    let mounted = true;
    const fetchAvatar = async () => {
      try {
        if ( me ) {
          const clientId = me.clients && me.clients.length > 0 ? me.clients[ 0 ].id : '';
          if ( clientId ) {
            const url = await AvatarService.getUserAvatar( me.id, clientId, token, dispatch );
            const finalUrl = url && url.startsWith( '/' ) ? `${window.location.origin}${url}` : url;
            if ( mounted ) { setAvatarUrl( finalUrl ); }
            return;
          }
        }
      } catch ( er ) {
        logger.error( 'Error fetching avatar url', er as Error );
        if ( mounted ) { setAvatarUrl( null ); }
      }
      if ( mounted ) { setAvatarUrl( null ); }
    };
    fetchAvatar();
    return () => { mounted = false; };
  }, [ me, token, dispatch ] );
  const navigate = useNavigate();

  return (
    <div className="flex-center py-3 px-0 md:px-10">
      <div className="flex items-center w-full">
        <hr className="min-w-[50px] h-1 border-none bg-orange-base w-10 rounded-full" />
        <span className="font-title text-6xl mx-4 text-pretty text-left w-fit">{title}</span>
        <hr className="min-w-[50px] h-1 border-none bg-orange-base flex-grow rounded-l-full" />
        {
          me ?
            <div className="border-4 border-orange-base border-r-0 rounded-l-full">
              <div
                className="flex p-2 gap-2 max-w-[350px] min-w-[200px] items-center cursor-pointer"
                onClick={ () => {
                  NavigationService.toUser( navigate, me.id, needConfirmationToNav );
                } }
              >
                <img
                  src={ avatarUrl ?? DefaultAvatar }
                  draggable="false"
                  className="w-14 h-14 rounded-full flex justify-center items-center p-1 select-none"
                  alt={ me.fullname }
                />
                <span className='text-ellipsis overflow-hidden'>
                  { me.fullname }
                </span>
              </div>
            </div>
            :
            null
        }
      </div>
    </div>
  );
}
